import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorCount: 0 };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const isPortalError = error?.message?.includes("removeChild") ||
      error?.message?.includes("insertBefore") ||
      error?.message?.includes("removeChildFromContainer");
    
    if (isPortalError && this.state.errorCount < 1) {
      // Recover once from portal errors by reloading the page
      this.setState({ hasError: false, errorCount: this.state.errorCount + 1 });
      window.location.reload();
      return;
    }
    
    console.error("ErrorBoundary caught:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 via-white to-blue-50">
          <div className="text-center p-8 max-w-md">
            <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl font-bold text-amber-600">!</span>
            </div>
            <h2 className="text-lg font-semibold text-slate-800 mb-2">Algo deu errado</h2>
            <p className="text-sm text-slate-500 mb-6">Ocorreu um erro inesperado. Tente recarregar a página.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-2.5 bg-teal-700 text-white rounded-lg hover:bg-teal-800 transition-colors text-sm font-medium"
              data-testid="error-reload-btn"
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
